import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/Header";
import Hero from "./components/Hero";
import WhatWeDo from "./components/WhatWeDo";
import GalaxyMap from "./components/GalaxyMap";
import Philosophy from "./components/Philosophy";
import Capabilities from "./components/Capabilities";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import AboutUs from "./components/AboutUs";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#050508]">
      <Header />
      <main>
        <Hero />
        <WhatWeDo />
        <GalaxyMap />
        <Philosophy />
        <Capabilities />
        <Contact />
      </main>
      <Footer />
      <Chatbot />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#0c0c10',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#ffffff',
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutUs />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
